export const ApiDateFormat = 'YYYY-MM-DD';
export const ApiTimestampFormat = 'MM-DD-YYYY HH:mm a z';
export const StfDateFormat = 'MM/DD/YY';
export const UkDateFormat = 'DD/MM/YY';
export const UkDateFullYearFormat = 'DD/MM/YYYY';
export const UserDateFormat = 'MM/DD/YY hh:mm A';
export const CmsDateFormat = 'MM/DD/YYYY';
export const ApiNoteTimestampFormat = 'YYYY-MM-DD HH:mm:ss';
export const utcTimestampFormat = 'YYYY-MM-DDTHH:mm:ss.SSSZZ';
export const ISOUiTimestampFormat = 'YYYY-MM-DDTHH:mm:ss.SSS';
export const StandardDateFormatString = 'MM-DD-YYYY';
export const StandardDateTimeFormatString = 'MM-DD-YYYY HH:mm:ss';
export const militaryTimeFormat = 'HH:mm';
export const StandardDateFormatStringForUK = 'DD-MM-YYYY';
